import { postJson, postObjectAsFormUrlEncoded, postFormUrlEncoded, fetchJson } from '../core/ajax-json.js';

function preparePaymentFormDataServiceCache() {
	const url = '/PaymentFormDataService/formEvent/playerEnterForm';
	const data = { deposit: false, mobileDevice: true };

	return postJson(url, data);
}

function fetchWithdrawPaymentMethods() {
	const url = '/PaymentFormDataService/getWithdrawPaymentMethods';
	const mobileDevice = 'isMobileDevice=true';

	return fetchJson(`${url}?${mobileDevice}`);
}
function fetchTemplateDataForMethod(url, params) {
	return postFormUrlEncoded(url, `${params}&isMobile=true`)
		.catch(e => {
			console.log(`Failed fetching credit card data. e=${e} url=${url}, post data:`, params);
			return Promise.reject(e);
		});
}
/* With header { cache: no-store }, url cache busting should not be needed. nginx proxy conf?
 * Solving the problem with url cache busting for now.
 * TODO: Investigate cache no-store header post MVP
 */
function fetchFeesAndLimits(data) {
	const url = `/PaymentFormDataService/geWithdrawFeesAndLimits/forMobile?t=${Date.now()}`;
	return postObjectAsFormUrlEncoded(url, data);
}
/* With header { cache: no-store }, url cache busting should not be needed. nginx proxy conf?
 * Solving the problem with url cache busting for now.
 * TODO: Investigate cache no-store header post MVP
 */
function fetchBalance() {
	const url = `/PaymentFormDataService/getWithdrawBalance?t=${Date.now()}`;
	return fetchJson(url);
}

function fetchPendingWithdraws() {
	return new Promise((resolve) => {
		setTimeout(() => {
			const POSSIBLE_WITHDRAWS = [{
				amount: 80,
				currency: 'SEK'
			}, {
				amount: 120,
				currency: 'SEK'
			}, {
				amount: 150,
				currency: 'SEK'
			}, {
				amount: 200,
				currency: 'SEK'
			}];
			const MIN = 0;
			const MAX = 0; // POSSIBLE_WITHDRAWS.length;
			const pendingCount = Math.random() * (MAX - MIN) + MIN;
			resolve(POSSIBLE_WITHDRAWS.slice(0, pendingCount));
		}, 50);
	});
}
function isKycNeeded(paymentMethodData) {
	const kycCheckParameters = paymentMethodData;
	kycCheckParameters.isMobileDevice = true;
	return fetchJson('/PaymentFormDataService/getValidateKYCStatus', kycCheckParameters);
	/* - Mock to Force KYC
		.then(() => {
			const kycResponse = {
				needValidation: true,
				kycPopup: {
					contentKYC: {
						uploadTitle: 'Upload Title',
						message: 'Kyc upload message.',
						uploadDocuments: ['Passport', 'National ID'],
					},
					confirm: 'Confirm KYC',
				}
			};
			return kycResponse;
		});
	*/
}

function isMobileVerifyNeeded() {
	return fetchJson('/PaymentFormDataService/getWithdrawVerification');
}

export {
	fetchPendingWithdraws,
	fetchWithdrawPaymentMethods,
	fetchTemplateDataForMethod,
	fetchFeesAndLimits,
	fetchBalance,
	isKycNeeded,
	isMobileVerifyNeeded,
	preparePaymentFormDataServiceCache,
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/withdraw-services.js